import { render, staticRenderFns } from "./avatar.vue?vue&type=template&id=7c70f12d&scoped=true&"
import script from "./avatar.vue?vue&type=script&lang=ts&"
export * from "./avatar.vue?vue&type=script&lang=ts&"
import style0 from "./avatar.vue?vue&type=style&index=0&id=7c70f12d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c70f12d",
  null
  
)

export default component.exports